module.exports = __webpack_public_path__ + "static/media/tinder.108d04d6.jpg";